//

import { useEffect } from "react";
import { useSelector } from "react-redux";
import ActionColumnArchived from "../../../components/JobModuleComponent/ArchivedTabComponent/ActionColumnArchived";
import AutoRefreshArchivedCheckbox from "../../../components/JobModuleComponent/ArchivedTabComponent/AutoRefreshArchivedCheckbox";
import DownloadModal from "../../../components/SharedComponent/ModalComponent/DownloadModal";
import TableColumn from "../../../components/SharedComponent/TableColumnComponent/TableColumn";
import TableComponent from "../../../components/SharedComponent/TableComponent/TableComponent";
import { fetchArchivedAudios, fetchPaginateArchivedAudios, resetArchivedTable, stopArchivedAutoRefresh, switchArchivedAutoFresh, updateArchivedRequestBody } from "../../../redux/JobModule/ArchivedPage/ArchivedAction";
import { stopNewCompletedAutoRefresh } from "../../../redux/JobModule/CompletedPage/NewCompletedAction";
import { stopInProgressAutoRefresh } from "../../../redux/JobModule/InProgressPage/InProgressAction";
import { RootState } from "../../../redux/store";
import { closeDownloadModal, openDownloadModal } from "../../../redux/Transcribe/TranscribeAction";
import { useAppDispatch } from "../../../redux/useAppDispatch";

function NewTabContent(props: any) {
  const dispatch = useAppDispatch();
  const archivedPageState = useSelector((state: RootState) => state.ArchivedAudiosState);
  const downloadModalState = useSelector((state: RootState) => state.TranscribeState.downloadModalState);

  const handleTableSorting = (sorter: any) => {
    const isAscend = (order: string) => {
      if (order === "ascend") {
        return true;
      }
      return false;
    };
    const newSortingRequestBody = {
      ...archivedPageState.currentRequestBody,
      SortColumn: sorter.field,
      IsAsc: isAscend(sorter.order),
    };
    dispatch(stopArchivedAutoRefresh());
    dispatch(resetArchivedTable());
    dispatch(updateArchivedRequestBody(newSortingRequestBody));
    dispatch(fetchArchivedAudios({}));
    dispatch(switchArchivedAutoFresh({ autoRefresh: true }));
  };

  //Each rendering
  useEffect(() => {
    // dispatch(switchArchivedAutoFresh({ autoRefresh: true }));
    dispatch(fetchArchivedAudios({}));
    dispatch(switchArchivedAutoFresh({ autoRefresh: true }));

    return () => {
      dispatch(stopArchivedAutoRefresh());
      dispatch(stopNewCompletedAutoRefresh());
      dispatch(stopInProgressAutoRefresh());
      dispatch(resetArchivedTable());
    };
  }, []);

  const ArchivedTableColumn = [
    ...TableColumn,
    {
      title: "Actions",
      key: "", //Need to add the key and dataIndex
      dataIndex: "",
      render: (value: any, record: any) => {
        return <ActionColumnArchived record={record} />;
      },
      width: 90,
    },
  ];

  return (
    <div className="body-container gap-3">
      <AutoRefreshArchivedCheckbox />
      <TableComponent
        columns={ArchivedTableColumn}
        dataSource={archivedPageState.data}
        pagination={archivedPageState.pagination}
        handleTableSorting={handleTableSorting}
        fetchPaginatedData={() => fetchPaginateArchivedAudios({})}
        loading={archivedPageState.loading}
        tableKey={"ArchivedTab"}
      />
      <DownloadModal
        openState={downloadModalState}
        open={() => dispatch(openDownloadModal())}
        close={() => dispatch(closeDownloadModal())}
      />
    </div>
  );
}

export default NewTabContent;
